export default __webpack_public_path__ + "e8cb302c4f8f6ed4dd01639918e6f722.svg";